// ----------------------------------------------------------------------
// <copyright file="Izenda.SubscriptionPopup.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * SubscriptionPopup Component
 */
!(function() {
  require('share/utils/Izenda.StringUtilities');

  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');

  var PopupInput = require('share/components/controls/Izenda.PopupInput');
  var SubscriptionGrid = require('./Izenda.SubscriptionGrid');
  var classnames = require('classnames');
  var REPORT_DESIGNER_CONSTANST = require('logic/data/Izenda.ReportDesignerConstants');
  const { find, isNil } = require('lodash/fp');
  var SubscriptionPopup = React.createClass({
    /**
     * Handle action when get value
     * @return {object}
     */
    onChange: function(value) {
      var store = this.props.store;
      store && store.saveInstances();
    },

    /**
     * Load data when open popup
     * @return {object}  Promise
     */
    onClick: function() {
      var store = this.props.store;
      store.updateReportId(this.props.reportId);
      return store.loadInstances();
    },

    /**
     * Render component
     * @return {[type]} [description]
     */
    render: function() {
      var localization = this.props.localization;

      var reportTypes = REPORT_DESIGNER_CONSTANST.TYPES;
      var reportTypeDefine =
        find(
          function(item) {
            return item.id === parseInt(this.props.reportType, 10);
          }.bind(this),
          reportTypes
        ) || {};

      var reportType = reportTypeDefine.value;
      var popupTitle = String.format('{0} {1}', reportType, localization.getText('SUBSCRIPTION_LABEL_SUBSCRIPTION'));

      var store = this.props.store || {};
      var containerClassName = classnames('report-subscription', {
        [`${this.props.className}`]: !isNil(this.props.className)
      });

      return (
        <PopupInput
          containerClassName={containerClassName}
          className="btn btn-primary"
          label={localization.getText('COMMON_LABEL_SUBSCRIBE')}
          onChange={this.onChange}
          popupProps={{
            type: 'none',
            autoClose: false,
            sizeClass: 'modal-lg',
            showSubscriptionPopup: this.props.showSubscriptionPopup,
            emailTemplates: store.model.emailTemplates
          }}
          popupContentProps={{
            confirmButtonLabel: localization.getText('COMMON_LABEL_SAVE'),
            beforeClosing: 'beforeClosing',
            showSubscriptionPopup: this.props.showSubscriptionPopup,
            emailTemplates: store.model.emailTemplates
          }}
          popupTitle={popupTitle}
          popupContent={SubscriptionGrid}
          store={store}
          onClick={this.onClick}
          pageConstants={this.props.pageConstants}
          onSavePopupDesigner={this.props.onSavePopupDesigner}
          isPopupMode
        />
      );
    }
  });

  module.exports = connect()(SubscriptionPopup);
})();



// WEBPACK FOOTER //
// ./ui/modules/Subscription/Izenda.SubscriptionPopup.jsx